import React from 'react'

import commonStyles from 'utils/styles/commonStyles'

import { Box, BoxPadding, BoxProps } from '../Box'

interface CardProps extends BoxProps {
  children: React.ReactNode
  margin?: BoxPadding
}

export const Card = ({
  children,
  backgroundColor = 'greyLight',
  margin = { horizontal: 'md', top: 'lg' },
  padding,
  ...props
}: CardProps) => {
  return (
    <Box
      style={commonStyles.overflowHidden}
      borderRadius='sm'
      margin={margin}
      padding={padding}
      shadow='md'
      backgroundColor={backgroundColor}
      {...props}
    >
      {children}
    </Box>
  )
}
